import script from "./ContactPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactPage.vue?vue&type=script&setup=true&lang=js"

import "./ContactPage.vue?vue&type=style&index=0&id=03de567b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03de567b"]])

export default __exports__